export const notificationAudienceLabels = { patient: "Patient", practitioner: "Practitioner", guest: "Guest" };
export const notificationChannelLabels = { in_app: "In-app", email: "Email", sms: "SMS", push: "Mobile push" };

export function groupNotificationSettings(settings) {
  const groups = [];
  const indexByEvent = new Map();
  for (const setting of settings || []) {
    const existing = indexByEvent.get(setting.eventType);
    if (existing) existing.settings.push(setting);
    else {
      const group = { eventType: setting.eventType, label: setting.label, timing: setting.timing, settings: [setting] };
      indexByEvent.set(setting.eventType, group);
      groups.push(group);
    }
  }
  return groups;
}

export function notificationSettingDirty(draft, saved) {
  return draft.enabled !== saved.enabled
    || draft.title !== saved.title
    || draft.content !== saved.content
    || draft.emailSubject !== saved.emailSubject
    || draft.emailContent !== saved.emailContent
    || draft.channels.length !== saved.channels.length
    || draft.channels.some(channel => !saved.channels.includes(channel));
}

export function mergeNotifications(legacy, scheduling) {
  const combined = [
    ...legacy.map(item => ({ ...item, source: "legacy" })),
    ...scheduling.map(item => ({ ...item, source: "scheduling", notificationId: item.id, timestamp: item.createdAt, markAsRead: !!item.readAt })),
  ];
  return [...new Map(combined.map(item => [`${item.source}:${item.notificationId}`, item])).values()]
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
}
export function notificationScheduleLink(target) {
  if (!target?.scheduleId || !target?.organizationRef) return null;
  return `/app/edit-schedule?${new URLSearchParams({ organizationRef: target.organizationRef, scheduleId: target.scheduleId })}`;
}
